<script>
	import { getText } from '../../../../share/utils';
</script>

<div class="page-middleclass-hoepfner marginbox">
	<div class="flex structure">
		<div class="flex col structure-1">
			<div class="flex element">
				<img loading="lazy" alt="Kein Mittelmaß - Höpfner - Visitenkarten-Design" src="./../img/15.Kein_Mittelmass/03.hoepfner/squares-mockup.webp">
			</div>
			<div class="flex element">
				<img loading="lazy" alt="Kein Mittelmaß - Höpfner - mobile-Design" src="./../img/15.Kein_Mittelmass/03.hoepfner/mobile.webp">
			</div>
			<div class="flex element">
				<div class="text">
					<h2>{getText("15.03.01_h2")}</h2>
					<p class="caption">{getText("15.03.02_caption")}</p>
				</div>
			</div>
		</div>
		
		<div class="flex col structure-2">
			<div class="flex element">
				<img loading="lazy" alt="Kein Mittelmaß - Höpfner - Brief-Design" src="./../img/15.Kein_Mittelmass/03.hoepfner/letter.webp">
			</div>
			<div class="flex element">
				<img loading="lazy" alt="Kein Mittelmaß - Höpfner - Formular-Design" src="./../img/15.Kein_Mittelmass/03.hoepfner/ticket.webp">
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: $spacing-mobile $spacing-mobile $media-gap $spacing-mobile;
	}
	
	h2,
	h2 {
		margin-bottom: $media-gap;
	}
	
	.page-middleclass-hoepfner {
		margin-top: $spacing-mobile;
		
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1,
		.structure-2,
		.structure-3 {
			width: 100%;
			padding: 0;
			position: relative;
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.structure-1 {
			margin-top: $spacing-mobile;
			align-items: end;
			justify-content: space-between;
			
			@include for-tablet-portrait-up {
				margin-top: 0;
				width: 50%;
			}
			
			> .element:nth-of-type(2) {
				@include for-tablet-portrait-up {
					width: 35%;
				}
			}
			> .element:nth-of-type(3) {
				justify-content: end;
			}

			.text {
				height: fit-content;
				display: flex;
				flex-direction: column;
				align-items: end;

				.caption {
					text-align: right;
				}
			}
		}
		
		.structure-2 {
			margin-bottom: $media-gap;
			
			@include for-tablet-portrait-up {
				width: 50%;
				padding-left: $media-gap;
			}
		}
		
		.text {
			margin: 0;
		}
	}
</style>
